import React from "react";
import { Button } from "../button";
import { HiOutlineLockOpen } from "react-icons/hi";
import styled from "styled-components";
import theme from "../../../../theme/themeThree";

const StyledExternal = styled(HiOutlineLockOpen)`
  position: relative;
  left: -5px;
  top: 4px;
  margin-right: ${(props) => props.theme.space[3]}px;
  top: ${(props) => props.theme.space[2]}px;
  margin-right: ${(props) => props.theme.space[3]}px;
`;

export function ResetButton(props) {
  return (
    <Button {...props}>
      <StyledExternal
        color={props.classification === "white" ? theme.colors.envy : "white"}
        size={24}
      />
      {props.children}
    </Button>
  );
}
